import { render, staticRenderFns } from "./TagListCreateOrEdit.vue?vue&type=template&id=57a36d4c&"
import script from "./TagListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./TagListCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports